// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3kqJf","selects":"Documents_selects__2d6k4"};